import { useEffect, useState } from "react";
import UserListing from "./UserListing";
import LogOutButton from "./LogOutButton";
import VisibilityButton from "./VisibilityButton";
import MyInfo from "./MyInfo";
import RecentActivity from "./RecentActivity";
import { uuidv4 as uuid } from "@firebase/util";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../utils/firebase";
import CommunityDashboardListing from "./CommunityDashboardListing";

export default function AdminPage({ user }) {
  const { userTypeNumber, community } = user;

  // const [roleAssignmentVis, setRoleAssignmentVis] = useState(true);
  const [activityVis, setActivityVis] = useState(false);

  const [queryState, setQueryState] = useState({
    isLoading: true,
    errorMessage: "",
    docSnapshots: null,
  });

  useEffect(() => {
    async function loader() {
      try {
        setQueryState({
          isLoading: true,
          errorMessage: "",
          docSnapshots: null,
        });
        const querySnapshot = await getDocs(collection(db, "Users"));
        const docs = querySnapshot.docs;
        setQueryState({
          isLoading: false,
          errorMessage: "",
          docSnapshots: docs,
        });
      } catch (error) {
        setQueryState({
          isLoading: false,
          errorMessage: "Error",
          docSnapshots: null,
        });
        console.log(error);
      }
    }

    loader();
  }, []);

  const { isLoading, errorMessage, docSnapshots } = queryState;

  let content;

  if (isLoading) {
    content = (
      <div
        className="spinner-border text-primary text-center justify-center mx-auto flex bg-user-home"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  } else if (errorMessage) {
    content = errorMessage;
  } else {
    content = (
      <UserListing
        data={docSnapshots}
        level={userTypeNumber}
        community={community}
      />
    );
  }

  return (
    <div key={uuid} className="bg-user-home text-center mx-md-5">
      <h1 style={{ marginBottom: 32, color: "#1d4a22" }}>Dashboard</h1>
      <div className="container">
      <div className="row">
        <div className="col-12 col-md-3">
          <MyInfo user={user} />
        </div>
        <div className="col-12 col-md-9">
          <CommunityDashboardListing />
          <br />
          {/* <VisibilityButton
        text={"Role Assignment"}
        setter={setRoleAssignmentVis}
        state={roleAssignmentVis}
      />
      {roleAssignmentVis ? (
        <div key={uuid} style={{ maxWidth: "90%", margin: "0 auto" }}>
          {content}
        </div>
      ) : null}
      <br /> */}
          <div style={{ margin: "3em auto 0" }}>
            <VisibilityButton
              text={"Recent Activity"}
              setter={setActivityVis}
              state={activityVis}
            />
          </div>

          {activityVis ? (
            <div style={{ maxWidth: "90%", margin: "0 auto" }}>
              <RecentActivity />
            </div>
          ) : null}
          <br />

          <LogOutButton />
        </div>
      </div>
      </div>

      <br />
    </div>
  );
}
